import { LayoutVerticalThumbnails } from './layouts/LayoutVerticalThumbnails';
import { LayoutHorizontal } from './layouts/LayoutHorizontal';
import { LAYOUT } from '../constants/Constants';
import { LayoutVertical } from './layouts/LayoutVertical';
export class LayoutFactory {
    static create(type, config, eventBus, assetViewerItems, tokenService, linkService, pdfJsLinkService) {
        switch (type) {
            case LAYOUT.HORIZONTAL:
                return new LayoutHorizontal(config, eventBus, assetViewerItems, tokenService, pdfJsLinkService);
            case LAYOUT.VERTICAL:
                return new LayoutVertical(config, eventBus, assetViewerItems, tokenService, pdfJsLinkService);
            case LAYOUT.VERTICAL_THUMBNAILS:
                return new LayoutVerticalThumbnails(config, eventBus, assetViewerItems, tokenService, linkService);
            default:
                throw new Error(`unknown layout: ${type}`);
        }
    }
}
//# sourceMappingURL=LayoutFactory.js.map